import { render, staticRenderFns } from "./footer_page.vue?vue&type=template&id=7be34f08&scoped=true"
import script from "./footer_page.vue?vue&type=script&setup=true&lang=js"
export * from "./footer_page.vue?vue&type=script&setup=true&lang=js"
import style0 from "./footer_page.vue?vue&type=style&index=0&id=7be34f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be34f08",
  null
  
)

export default component.exports